import { ReactElement } from 'react';
import CollectionSummary, { CollectionSummaryProps } from '../collection-summary/CollectionSummary';
import styles from './CollectionTableHeader.module.scss';

export interface CollectionTableHeaderProps extends CollectionSummaryProps {
  showSummaryInTable?: boolean;
  enableColumnSelection?: boolean;
}

export const CollectionTableHeader = ({
  modelName,
  filterProps,
  secondaryModelName,
  countAll,
  showSummaryInTable = false,
  enableColumnSelection = false,
}: CollectionTableHeaderProps): ReactElement => {
  return (
    <div className={styles.header}>
      {showSummaryInTable && (
        <CollectionSummary
          filterProps={filterProps}
          modelName={modelName}
          secondaryModelName={secondaryModelName}
          countAll={countAll}
        />
      )}
      {enableColumnSelection && <div>{/* TODO: Column Selection */}</div>}
    </div>
  );
};

export default CollectionTableHeader;
